import { render, staticRenderFns } from "./ModuleBuilder.vue?vue&type=template&id=7eb7ff1f"
import script from "./ModuleBuilder.vue?vue&type=script&lang=js"
export * from "./ModuleBuilder.vue?vue&type=script&lang=js"
import style0 from "./ModuleBuilder.vue?vue&type=style&index=0&id=7eb7ff1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports